import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, Spinner, Button } from 'reactstrap'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import CalendarLocale from '@fullcalendar/core/locales/pt-br'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getProducts, getProductsFromOikos } from '../../../store/ducks/technicalDep'
import { getProductsFromOikosToGrid as getProductsToGrid, selectValues } from '../../../utils/fc/index'
import { getReceitasFromOikos, getRegs } from '../../../utils/fc'
import { notifyError } from '../../../utils/notify'
import moment from 'moment'
import {MaterialReactTable} from 'material-react-table'
import currencyFormatter from '../../../utils/currencyFormatter'
import * as XLSX from 'xlsx'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Box, Typography, Modal } from '@mui/material'
import GridProductsCalendar from '../../../components/GridProductsCalendar/GridProductsCalendar'
import Legenda from '../../../components/Legenda/Legenda'
import DashboardProdutos from './DashboardProdutos'
import { parseDate } from '../../../utils/monthRef'
import { PROD_STATUS_LABELS, prodStatusLabel } from './dashboardProdutosHelpers'
import '../../../assets/css/custom-fc-event.css'

// Número de série do Excel (sistema 1900) a partir do dia civil local.
// Um Date passado ao SheetJS é convertido com o fuso de 1899 (em Brasília,
// GMT-0306) e a meia-noite local vira o dia anterior na planilha.
const excelSerialDate = (value) => {
  const d = parseDate(value);
  if (!d) return null;
  const utcDays = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const excelEpoch = Date.UTC(1899, 11, 30);
  return (utcDays - excelEpoch) / 86400000;
};

const dateSortValue = (value) => {
  const d = parseDate(value);
  return d ? d.getTime() : null;
};

const formatDateCell = (value) => {
  const d = parseDate(value);
  return d ? moment(d).format('DD/MM/YYYY') : undefined;
};

const revisionColumnHeader = (n) => `Data entrega da revisão ${n} para o cliente`;

// Reentrega ao cliente: um status 6 que vem depois de um status 9,
// e esse 9 vem depois de um status 6 anterior. O primeiro 6 é a entrega original.
const revisionDeliveryDates = (events) => {
  const ordered = (events || [])
    .filter((event) => {
      const tp = Number(event?.prodStatusTp_id);
      return (tp === 6 || tp === 9) && parseDate(event?.prodStatusAlt_data);
    })
    .sort((a, b) => parseDate(a.prodStatusAlt_data).getTime() - parseDate(b.prodStatusAlt_data).getTime());

  const dates = [];
  let seenDelivery = false;
  let awaitingRedelivery = false;
  ordered.forEach((event) => {
    const tp = Number(event.prodStatusTp_id);
    if (tp === 6) {
      if (awaitingRedelivery) {
        dates.push(event.prodStatusAlt_data);
        awaitingRedelivery = false;
      }
      seenDelivery = true;
      return;
    }
    if (seenDelivery) awaitingRedelivery = true;
  });
  return dates;
};

const loadRevisionDeliveryDates = async (products) => {
  const ids = new Set(
    products.map((product) => Number(product.prod_id)).filter((id) => Number.isFinite(id))
  );
  const [status6, status9] = await Promise.all([
    getRegs('prodStatusAlt', { prodStatusTp_id: 6 }),
    getRegs('prodStatusAlt', { prodStatusTp_id: 9 }),
  ]);
  if (!Array.isArray(status6) || !Array.isArray(status9)) return null;

  const grouped = new Map();
  [...status6, ...status9].forEach((row) => {
    const id = Number(row.prod_id);
    if (!ids.has(id)) return;
    if (!grouped.has(id)) grouped.set(id, []);
    grouped.get(id).push(row);
  });

  const byProd = new Map();
  ids.forEach((id) => {
    byProd.set(id, revisionDeliveryDates(grouped.get(id) || []));
  });
  return byProd;
};

let tooltipTimeout;

class Products extends Component {

  constructor(props) {
    super(props)
    this.state = {
      products: null,
      calendarDateOption: 'Data prevista',
      selectedView: 'products',
      isModalOpen: false,
      receitasCalendarDateOption: 'Data limite faturamento',
      isReceitasModalOpen: false,
      isReceitasCalendar: true,
      receitas: [],
      selectedReceitasProjeto: null,
      recInfo: {},
      isReceitasLoading: true,
      isCalendar: true,
      isTable: false,
      isGrid: false,
      isExportingXlsx: false,
      selectedProductsProjeto: null,
      productInfo: {},
      selectFilterTecnicoOptions: [],
      selectFilterProjetoOptions: [],
      filteredProducts: null,
      originalStylePageContent: {},
      originalStyleContainerFluid: {},
    }
    this.mrtRef = React.createRef();
  }


  componentDidMount() {
    const { getProductsFromOikos } = this.props
    getProductsFromOikos()
    this.getProjectsSelectOptions();
    this.handleReceitas()
  }

  preloadingGridData = async () => {
    this.getGanttData()
    const selectTecnicoOptions = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {dpto_id: 4});
    const selectProjetoOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1});
    this.setState({selectFilterTecnicoOptions: selectTecnicoOptions, selectFilterProjetoOptions: selectProjetoOptions})
  }

  getProjectsSelectOptions = async () => {
    const selectProjetoOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1});
    this.setState({selectFilterProjetoOptions: selectProjetoOptions})
  }

  handleOpenModal = () => this.setState({isModalOpen: true});
  handleCloseModal = () => this.setState({isModalOpen: false});
  handleOpenReceitasModal = () => this.setState({isReceitasModalOpen: true});
  handleCloseReceitasModal = () => this.setState({isReceitasModalOpen: false});

  handleReceitas = async () => {
    try {
      const receitas = await getReceitasFromOikos()
      this.setState({ receitas, isReceitasLoading: false })
    } catch (error) {
      this.setState({ isReceitasLoading: false })
    }
  }

  filterArray = (array, key, value) => {
    const filteredArray = array.filter((item) => item[key] === value);
    return filteredArray;
  }


  getArrayMonthsYears = () => {
    document.getElementById('generateMonths').addEventListener('click', () => {
      const minDateInput = document.getElementById('minDate').value;
      const maxDateInput = document.getElementById('maxDate').value;

      if (!minDateInput || !maxDateInput) {
        console.error('Both minimum and maximum dates must be provided.');
        return;
      }

      const minDate = new Date(`${minDateInput}-01T00:00:00-03:00`);
      const maxDate = new Date(`${maxDateInput}-01T00:00:00-03:00`);

      if (minDate > maxDate) {
        console.error('Minimum date cannot be greater than maximum date.');
        return;
      }

      const monthsObject = {};
      let currentDate = new Date(minDate);

      while (currentDate <= maxDate) {
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const key = `${year}-${month}`;

        // Get the number of days in the current month
        const daysInMonth = new Date(year, currentDate.getMonth() + 1, 0).getDate();

        // Create an array of days
        monthsObject[key] = Array.from({ length: daysInMonth }, (_, i) => i + 1);

        // Move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      this.setState({objectToConsultProductsInSQL: monthsObject});
    });
  }

  getGanttData = () => {
    const arrayOfDaysToConsultInSQL = this.getArrayOfDaysToConsultInSQL(this.state.objectToConsultProductsInSQL);
    this.getProducts(arrayOfDaysToConsultInSQL);
  }

  updateRows = (newRows) => {
    this.setState({filteredProducts: newRows})
  }

  getProducts = async (arrayOfDaysToConsultInSQL) => {
    const productsFromOikos = await getProductsToGrid(arrayOfDaysToConsultInSQL)
    this.setState({products: productsFromOikos})
    if (this.state.filteredProducts) {
      const respId = this.state.filteredProducts[0].prod_responsavel;
      this.setState({filteredProducts: productsFromOikos.filter(product => product.prod_responsavel === respId)});
    }
  }

  getArrayOfDaysToConsultInSQL = (obj) => {
    const arrayDaysToConsultInSQL = [];
    Object.keys(obj).forEach(key => {
      obj[key].forEach(
        day => {
          arrayDaysToConsultInSQL.push(`${key}-${day <= 9 ? `0${day}` : `${day}`}`);
        }
      )
    });

    return arrayDaysToConsultInSQL;
  }

  getProductResume = (e) => {
    this.setState({
      productInfo: {
        prod_responsavelNome: e.event.extendedProps.prod_responsavelNome ?? e.event.extendedProps.prod_responsavelNomeAtual,
        proj_nome: e.event.extendedProps.proj_nome,
        prod_desc: e.event.title
      }
    });
  }

  getReceitaResume = (e) => {
    this.setState({
      recInfo: {
        rec_ep: e.event._def.extendedProps.rec_ep,
        rec_vlrBru: e.event._def.extendedProps.rec_vlrBru,
        rec_vlrLiq: e.event._def.extendedProps.rec_vlrLiq,
        rec_fat: e.event._def.extendedProps.rec_fat,
        rec_risco: e.event._def.extendedProps.rec_risco,
        rec_dtQuitAtual: e.event._def.extendedProps.rec_dtQuitAtual,
        rec_dtQuitIni: e.event._def.extendedProps.rec_dtQuitIni,
        rec_dtNfPrev: e.event._def.extendedProps.rec_dtNfPrev,
        recProjeto: e.event._def.extendedProps.recProjeto,
      }
    });
  }

  handleEventMouseEnter = (e) => {
    clearTimeout(tooltipTimeout);

    const { clientX, clientY } = e.jsEvent;

    let tooltip = document.getElementById("fc-hover-tooltip");

    if (!tooltip) {
      tooltip = document.createElement("div");
      tooltip.className = "fc-hover-tooltip-global";
      tooltip.setAttribute("id", "fc-hover-tooltip");

      // Tooltip hover behavior
      tooltip.addEventListener('mouseleave', () => {
        tooltipTimeout = setTimeout(() => tooltip.remove(), 300);
      });

      tooltip.addEventListener('mouseenter', () => {
        clearTimeout(tooltipTimeout);
      });

      document.body.appendChild(tooltip);
    }

    // Always update content and position when hovering any event
    tooltip.innerHTML = `
      <div>
        <strong style="display:block; margin-bottom: 3px;">${e.event.title}</strong><br/>
        <span style="display:block; margin-bottom: 3px;">Projeto: ${e.event.extendedProps.proj_nome}</span><br/>
        Responsável: ${e.event.extendedProps.prod_responsavelNome ?? e.event.extendedProps.prod_responsavelNomeAtual}
      </div>
    `;

    Object.assign(tooltip.style, {
      position: "fixed",
      top: `${clientY + 4}px`,
      left: `${clientX + 4}px`,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "10px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      zIndex: "9999",
      whiteSpace: "wrap",
      pointerEvents: "auto",
      maxWidth: "200px",
    });
  };

  handleEventMouseLeave = () => {
    tooltipTimeout = setTimeout(() => {
      const tooltip = document.getElementById("fc-hover-tooltip");
      if (tooltip) tooltip.remove();
    }, 300);
  };

  expandTable = () => {
    const pageContent = document.querySelector('.page-content');
    const containerFluid = document.querySelector('.page-content .container-fluid');

    this.setState({originalStylePageContent: pageContent.style, originalStyleContainerFluid: containerFluid.style});

    containerFluid.style.maxWidth = "100%";

    pageContent.style.paddingLeft = "0px";
    pageContent.style.paddingRight = "0px";

    return true;
  }

  shrinkTable = () => {
    const pageContent = document.querySelector('.page-content');

    const containerFluid = document.querySelector('.page-content .container-fluid');

    containerFluid.style = this.state.originalStyleContainerFluid;
    pageContent.style = this.state.originalStylePageContent;

    return true;
  }

  render() {
    const { getProductsFromOikosIsLoading, productsFromOikos } = this.props.technicalDep
    const { calendarDateOption } = this.state
    const filteredProductsCalendar = this.state.selectedProductsProjeto
      ? productsFromOikos.filter((product) => product.proj_nome === this.state.selectedProductsProjeto.label)
      : productsFromOikos
    const filteredReceitas = this.state.selectedReceitasProjeto
      ? this.state.receitas.filter((rec) => rec.recProjeto === this.state.selectedReceitasProjeto.label)
      : this.state.receitas
    //const { isManager } = this.props.auth.user

    const xlsxExporter = (data, header, revisionDatesByProdId) => {
      const baseDateFields = ['Data Contratual', 'Data Interna', 'Data Entrega', 'Data Aprovação', 'Data aprovação financeira', 'Data Limite Aprovação'];
      const revisionsByRow = data.map((dado) => revisionDatesByProdId.get(Number(dado.prod_id)) || []);
      const revisionCount = revisionsByRow.reduce((max, dates) => Math.max(max, dates.length), 0);
      const revisionHeaders = Array.from({ length: revisionCount }, (_, index) => revisionColumnHeader(index + 1));
      const dateFields = [...baseDateFields, ...revisionHeaders];
      const sheetHeaders = [...header.map((coluna) => coluna.header), ...revisionHeaders];

      const dadosComHeadersRenomeados = data.map((dado, rowIndex) => {
        const novoDado = {}
        header.forEach((coluna) => {
          const fieldKey = coluna.accessorKey ?? coluna.id;
          if (coluna.header === 'Status') {
            novoDado[coluna.header] = prodStatusLabel(dado[fieldKey]);
          } else if (baseDateFields.includes(coluna.header)) {
            novoDado[coluna.header] = excelSerialDate(dado[fieldKey]);
          } else if (typeof coluna.accessorFn === 'function') {
            novoDado[coluna.header] = coluna.accessorFn(dado);
          } else {
            novoDado[coluna.header] = dado[fieldKey];
          }
        });
        revisionHeaders.forEach((revisionHeader, revisionIndex) => {
          const value = revisionsByRow[rowIndex][revisionIndex];
          novoDado[revisionHeader] = value ? excelSerialDate(value) : null;
        });
        return novoDado;
      });

      const worksheet = XLSX.utils.json_to_sheet(dadosComHeadersRenomeados, { header: sheetHeaders });
      worksheet['!cols'] = sheetHeaders.map((name) => {
        if (name === 'Status') return { wch: 28 };
        if (name === 'Data aprovação financeira') return { wch: 28 };
        if (name.startsWith('Data entrega da revisão')) return { wch: 44 };
        if (baseDateFields.includes(name)) return { wch: 16 };
        if (name === 'Projeto' || name === 'Descrição') return { wch: 36 };
        return { wch: 22 };
      });
      if (!worksheet['!ref']) {
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')
        XLSX.writeFile(workbook, 'dados.xlsx')
        return
      }

      const statusCol = sheetHeaders.indexOf('Status');
      if (statusCol >= 0) {
        data.forEach((dado, index) => {
          const label = prodStatusLabel(dado.prodStatusActual_id);
          if (!label) return;
          const cellRef = XLSX.utils.encode_cell({ r: index + 1, c: statusCol });
          worksheet[cellRef] = { t: 's', v: label, z: '@' };
        });
      }

      dateFields.forEach((dateField) => {
        const colIndex = sheetHeaders.indexOf(dateField);
        if (colIndex < 0 || colIndex === statusCol) return;
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let row = range.s.r + 1; row <= range.e.r; row++) {
          const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
          if (worksheet[cellRef] && worksheet[cellRef].v) {
            worksheet[cellRef].z = 'yyyy-mm-dd';
          }
        }
      });

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')
      XLSX.writeFile(workbook, 'dados.xlsx')
    }

    const handleExportData = async (exportFormat) => {
      if (exportFormat !== 'xlsx') {
        console.log('Formato não reconhecido')
        return
      }
      if (this._exportingXlsx) return

      const displayedData = this.mrtRef.current.getRowModel().rows.map((row) => row.original);
      this._exportingXlsx = true
      this.setState({ isExportingXlsx: true })
      try {
        const revisionDatesByProdId = await loadRevisionDeliveryDates(displayedData)
        if (!revisionDatesByProdId) {
          notifyError('Não foi possível carregar as datas de revisão para o Excel.')
          return
        }
        xlsxExporter(displayedData, columns, revisionDatesByProdId)
      } finally {
        this._exportingXlsx = false
        this.setState({ isExportingXlsx: false })
      }
    }


    const columns = [
      {
        accessorKey: 'proj_nome',
        header: 'Projeto',
        size: 300,
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'prod_desc',
        header: 'Descrição',
        size: 300,
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'prod_responsavelNome',
        header: 'Responsável',
        accessorFn: (row) => row.prod_responsavelNome ?? row.prod_responsavelNomeAtual,
        size: 200,
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'prodStatusActual_id',
        header: 'Status',
        accessorFn: (row) => prodStatusLabel(row.prodStatusActual_id),
        Cell: ({ cell, row }) => prodStatusLabel(row.original.prodStatusActual_id),
        size: 150,
        filterSelectOptions: Object.values(PROD_STATUS_LABELS),
        filterVariant: 'multi-select'
      },
      /*
      {
        accessorKey: 'prod_vlr',
        header: 'Valor',
        accessorFn: (row) => row.prod_vlr,
        size: 50,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.prod_vlr) return currencyFormatter.format(cell.getValue())
        },
        filterVariant: 'range'
      },
      */
      {
        accessorKey: 'prod_dtContrato',
        header: 'Data Contratual',
        accessorFn: (row) => dateSortValue(row.prod_dtContrato),
        size: 100,
        Cell: ({ cell, row }) => formatDateCell(row.original.prod_dtContrato),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'prod_dtInterna',
        header: 'Data Interna',
        accessorFn: (row) => dateSortValue(row.prod_dtInterna),
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => formatDateCell(row.original.prod_dtInterna),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
      },
      {
        accessorKey: 'prodEntregueAoClienteData',
        header: 'Data Entrega',
        accessorFn: (row) => dateSortValue(row.prodEntregueAoClienteData),
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => formatDateCell(row.original.prodEntregueAoClienteData),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
      },
      {
        accessorKey: 'prodAprovacaoData',
        header: 'Data Aprovação',
        accessorFn: (row) => dateSortValue(row.prodAprovacaoData),
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => formatDateCell(row.original.prodAprovacaoData),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
      },
      {
        accessorKey: 'prodAprovFinData',
        header: 'Data aprovação financeira',
        accessorFn: (row) => dateSortValue(row.prodAprovFinData),
        size: 120,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => formatDateCell(row.original.prodAprovFinData),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
      },
      {
        accessorKey: 'prod_dtLimAprov',
        header: 'Data Limite Aprovação',
        accessorFn: (row) => dateSortValue(row.prod_dtLimAprov),
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => formatDateCell(row.original.prod_dtLimAprov),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
      },
    ]

    if (getProductsFromOikosIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (!getProductsFromOikosIsLoading && productsFromOikos) {
      return (
        <div className="page-content">
          <Container fluid>

            <Breadcrumbs
              title="Produtos"
              breadcrumbItems={[]}
            />

            <Row className="mb-3">
              <Col>
                <div className="d-flex align-items-center">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="products-view-radio"
                      name="products-receitas-view"
                      checked={this.state.selectedView === 'products'}
                      onChange={() => this.setState({ selectedView: 'products' })}
                    />
                    <label className="form-check-label" htmlFor="products-view-radio">
                      Produtos
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="receitas-view-radio"
                      name="products-receitas-view"
                      checked={this.state.selectedView === 'receitas'}
                      onChange={() => {
                        this.shrinkTable()
                        this.setState({ selectedView: 'receitas' })
                      }}
                    />
                    <label className="form-check-label" htmlFor="receitas-view-radio">
                      Receitas
                    </label>
                  </div>
                </div>
              </Col>
            </Row>

            {this.state.selectedView === 'products' && (
              <>
            <Row className="mb-3 justify-content-between">

              <div className='d-flex justify-content-between'>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isTable ? '#4e515e' : '#74788d'}}
                  onClick={() => {

                    this.expandTable()

                    this.setState({
                      isGrid: false,
                      isCalendar: false,
                      isDashboard: false,
                      isTable: true,
                    })
                  }}
                >
                  Tabela
                </Button>
                <Button
                  style={{backgroundColor: this.state.isCalendar ? '#4e515e' : '#74788d'}}
                  className='mr-2'
                  onClick={() => {
                    this.shrinkTable()
                    this.setState({
                      isGrid: false,
                      isDashboard: false,
                      isCalendar: true,
                      isTable: false,
                    })
                  }}
                >
                  Calendário
                </Button>
                {/*
                */}
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isGrid ? '#4e515e' : '#74788d'}}
                  onClick={() => {
                    this.shrinkTable()
                    this.setState({
                      isGrid: true,
                      isDashboard: false,
                      isCalendar: false,
                      isTable: false,
                    })
                  }}
                >
                  Grade
                </Button>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isDashboard ? '#4e515e' : '#74788d'}}
                  onClick={() => {
                    this.shrinkTable()
                    this.setState({
                      isGrid: false,
                      isDashboard: true,
                      isCalendar: false,
                      isTable: false,
                    })
                  }}
                >
                  Dashboard
                </Button>
                <Button
                  className='mr-2'
                  style={{backgroundColor: '#74788d'}}
                  tag={Link}
                  to="/dep-tecnico/dashboard-entregas"
                >
                  Dashboard de entregas
                </Button>
                {/*
                */}
                {this.state.isTable &&
                <Button
                onClick={() => handleExportData('xlsx')}
                startIcon={<FileDownloadIcon />}
                variant="contained"
                disabled={this.state.isExportingXlsx}
                >
                  {this.state.isExportingXlsx ? 'Exportando…' : 'XLSX'}
                </Button>
                }
              </div>
              {this.state.isCalendar &&
                <div className="d-flex">
                  <Col style={{ zIndex: 2, width: "20rem" }}>
                    <label className="mb-1">Filtro por data</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      defaultValue={{
                        value: 'Data prevista',
                        label: 'Data prevista',
                      }}
                      options={[
                        {
                          value: 'Data prevista',
                          label: 'Data prevista',
                        },
                        {
                          value: 'Data contratual',
                          label: 'Data contratual',
                        },
                        {
                          value: 'Data de entrega',
                          label: 'Data de entrega',
                        },
                      ]}
                      onChange={({ value }) => this.setState({ calendarDateOption: value })}
                    />
                  </Col>
                  <Col style={{ zIndex: 2, width: "20rem" }}>
                    <label className="mb-1">Filtro por projeto</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={this.state.selectedProductsProjeto}
                      options={this.state.selectFilterProjetoOptions}
                      onChange={(selectedOption) => this.setState({ selectedProductsProjeto: selectedOption })}
                    />
                  </Col>
                </div>
              }
            </Row>

            { this.state.isCalendar &&
              <Row>
                <Col>
                  <div style={{marginTop: "32px"}}>
                    <Legenda objLegenda={{"Produto Entregue": "green", "Produto com entrega atrasada" : "red", "Produto no prazo" : "grey"}}/>
                  </div>
                  <Card>
                    <CardBody>
                      <FullCalendar
                        eventMouseEnter={this.handleEventMouseEnter}
                        eventMouseLeave={this.handleEventMouseLeave}
                        //eventClick={(e)=>{this.getProductResume(e); this.handleOpenModal()}}
                        handleWindowResize
                        locale={CalendarLocale}
                        plugins={[dayGridPlugin]}
                        defaultView="dayGridMonth"
                        headerToolbar={{
                          left: 'prev,next today',
                          center: 'title',
                          right: 'dayGridMonth,dayGridWeek,dayGridDay',
                        }}
                        events={filteredProductsCalendar.map((product, index) => {
                              // Parse the date using the Brazilian time zone
                              const currentDate = moment().format('YYYY-MM-DD'); // get the current date without time
                              return {
                                id: index,
                                title: product.prod_desc,
                                prod_id: product.prod_id,
                                prod_responsavelNome: product.prod_responsavelNome ?? product.prod_responsavelNomeAtual,
                                proj_nome: product.proj_nome,
                                allDay: true,
                                start:
                                  calendarDateOption === 'Data prevista' ? product.prod_dtInterna
                                  : calendarDateOption === 'Data contratual' ? product.prod_dtContrato
                                  : calendarDateOption === 'Data de entrega' ? product.prodEntregueAoClienteData
                                  : null,
                                color: (new Date(product.prod_dtContrato) < new Date(currentDate) && (!product.prodEntregueAoClienteData))
                                  ? 'red'
                                  : (product.prodEntregueAoClienteData || product.prodAprovacaoData) ? 'green' : 'grey',
                        }})}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            }

            { this.state.isTable &&
              <MaterialReactTable
                tableInstanceRef={this.mrtRef}
                columns={columns}
                data={productsFromOikos}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 500 },
                  sorting: [{ id: 'prodStatusActual_id', desc: false }],
                }}
                filterFns={{
                  dateRangeFilterFn: (row, id, filterValue) => {

                    if (!filterValue || !filterValue[0] || !filterValue[1]) {
                      return true; // Return true to show all rows if the filter is cleared
                    }

                    return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                  },

                }}
                enableFacetedValues
                enableGrouping
                enableGlobalFilter={true}
                enableFilters={true}
                enablePagination={true}
                muiTopToolbarProps={{sx: {
                  '.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"},
                  '.MuiSvgIcon-root': {width: '12px'},
                  '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
                  '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
                  '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
                }}}

                muiTableBodyCellProps={{sx: {fontSize: "13px", whiteSpace: 'normal', overflowWrap: 'break-word', maxWidth: "300px"}}}

                muiTablePaginationProps={{
                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
                labelRowsPerPage: <span style={{fontSize: "12px"}}>Projetos por página</span>,
                rowsPerPageOptions: [500, 2000],
                }}
                positionPagination='bottom'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableDensityToggle={false}
                enableColumnFilters={true}
                muiTableHeadCellProps={{
                  sx: {
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}

                muiTableBodyRowProps={({ row }) => ({
                  onClick: () => {
                    const project = row.original;

                    this.setState({
                      openProjectModalIsOpen: true,
                      openProjectData: {
                      ...project,
                    },
                  })},
                  sx: { cursor: 'pointer' },
                })}

                muiTableHeadCellFilterTextFieldProps={{
                  sx: {
                  color: "red",
                  }
                }}
              />
            }
              </>
            )}

            {this.state.selectedView === 'receitas' && (
              <>
                <Row className="mb-3 justify-content-between align-items-center">
                    <Button
                      className='mr-2'
                      style={{
                        backgroundColor: this.state.isReceitasCalendar ? '#4e515e' : '#74788d',
                        height: "3rem"
                      }}
                      onClick={() => {
                        this.setState({ isReceitasCalendar: true })
                      }}
                    >
                      Calendário
                    </Button>

                  {this.state.isReceitasCalendar &&
                    <div className="d-flex">
                      <Col style={{ zIndex: 2, width: "20rem" }}>
                        <label className="mb-1">Filtro por data</label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={false}
                          isSearchable={false}
                          defaultValue={{
                            value: 'Data limite faturamento',
                            label: 'Data limite faturamento',
                          }}
                          options={[
                            {
                              value: 'Data prevista quitação',
                              label: 'Data prevista quitação',
                            },
                            {
                              value: 'Data limite faturamento',
                              label: 'Data limite faturamento',
                            },
                          ]}
                          onChange={({ value }) => this.setState({ receitasCalendarDateOption: value })}
                        />
                      </Col>
                      <Col style={{ zIndex: 2, width: "20rem" }}>
                        <label className="mb-1">Filtro por projeto</label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={this.state.selectedReceitasProjeto}
                          options={this.state.selectFilterProjetoOptions}
                          onChange={(selectedOption) => this.setState({ selectedReceitasProjeto: selectedOption })}
                        />
                      </Col>
                    </div>
                  }
                </Row>

                {this.state.isReceitasLoading ? (
                  <div className="centered">
                    <Spinner />
                  </div>
                ) : (
                  this.state.isReceitasCalendar && (
                    <>
                      <div style={{marginTop: "32px"}}>
                        <Legenda objLegenda={{"Faturada": "blue", "Fatura atrasada" : "red", "No prazo mas não faturada" : "green"}}/>
                      </div>
                      <Row>
                        <Col>
                          <Card>
                            <CardBody>
                              <FullCalendar
                                eventClick={(e) => { this.getReceitaResume(e); this.handleOpenReceitasModal() }}
                                handleWindowResize
                                locale={CalendarLocale}
                                plugins={[dayGridPlugin]}
                                defaultView="dayGridMonth"
                                headerToolbar={{
                                  left: 'prev,next today',
                                  center: 'title',
                                  right: 'dayGridMonth,dayGridWeek,dayGridDay',
                                }}
                                events={filteredReceitas.map((rec, index) => {
                                  const currentDate = moment().format('YYYY-MM-DD');
                                  const colorDataLimiteFat = (rec.rec_fat === 1)
                                    ? 'blue'
                                    : (new Date(rec.rec_dtNfPrev) > new Date(currentDate)) ? 'green' : 'red';

                                  const colorDataPrevistaQuit = (rec.rec_risco === 0)
                                    ? 'blue'
                                    : (new Date(rec.rec_dtQuitAtual) > new Date(currentDate)) ? 'green' : 'red';

                                  return {
                                    id: index,
                                    title: rec.rec_ep,
                                    rec_vlrBru: rec.rec_vlrBru,
                                    rec_vlrLiq: rec.rec_vlrLiq,
                                    rec_fat: rec.rec_fat,
                                    rec_risco: rec.rec_risco,
                                    rec_dtQuitAtual: rec.rec_dtQuitAtual,
                                    rec_dtQuitIni: rec.rec_dtQuitIni,
                                    rec_dtNfPrev: rec.rec_dtNfPrev,
                                    rec_ep: rec.rec_ep,
                                    recProjeto: rec.recProjeto,
                                    allDay: true,
                                    start:
                                      this.state.receitasCalendarDateOption === 'Data limite faturamento' ? rec.rec_dtNfPrev
                                      : this.state.receitasCalendarDateOption === 'Data prevista quitação' ? rec.rec_dtQuitAtual
                                      : null,
                                    color:
                                      this.state.receitasCalendarDateOption === 'Data limite faturamento' ? colorDataLimiteFat
                                      : this.state.receitasCalendarDateOption === 'Data prevista quitação' ? colorDataPrevistaQuit
                                      : null,
                                  }
                                })}
                              />
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </>
                  )
                )}
              </>
            )}

          </Container>
          {
            this.state.selectedView === 'products' && this.state.isGrid &&
            <div style={{marginTop: "50px"}}>
              <GridProductsCalendar
                rows={productsFromOikos}
                selectFilterTecnicoOptions={this.state.selectFilterTecnicoOptions}
                selectFilterProjetoOptions={this.state.selectFilterProjetoOptions}
              />
            </div>
          }

          {/*
          */
         this.state.selectedView === 'products' && this.state.isDashboard &&
         <div style={{marginTop: "50px"}}>
            {console.log(productsFromOikos.filter(p=>p.prod_ativo===1))}
           <DashboardProdutos produtos={productsFromOikos.filter(p=>p.prod_ativo===1)}/>
         </div>
          }
          <Modal
            open={this.state.isModalOpen}
            onClose={this.handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
            }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Resumo do produto
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <p>Produto: {this.state.productInfo.prod_desc}</p><br/>
                <p>Projeto: {this.state.productInfo.proj_nome}</p><br/>
                <p>Responsável: {this.state.productInfo.prod_responsavelNome ?? this.state.productInfo.prod_responsavelNomeAtual}</p><br/>
              </Typography>
              <Button onClick={this.handleCloseModal}>Voltar</Button>
            </Box>
          </Modal>
          <Modal
            open={this.state.isReceitasModalOpen}
            onClose={this.handleCloseReceitasModal}
            aria-labelledby="modal-modal-title-receitas"
            aria-describedby="modal-modal-description-receitas"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
            }}>
              <Typography id="modal-modal-title-receitas" variant="h6" component="h2">
                Resumo da receita
              </Typography>
              <Typography id="modal-modal-description-receitas" sx={{ mt: 2 }}>
                <span>Receita: {this.state.recInfo.rec_ep}</span><br/>
                <span>Projeto: {this.state.recInfo.recProjeto}</span><br/>
                <span>Valor Bruto: {this.state.recInfo.rec_vlrBru ? currencyFormatter.format(this.state.recInfo.rec_vlrBru) : '-'}</span><br/>
                <span>Valor Líquido: {this.state.recInfo.rec_vlrLiq ? currencyFormatter.format(this.state.recInfo.rec_vlrLiq) : '-'}</span><br/>
                <span>Faturado: {this.state.recInfo.rec_fat === 1 ? 'SIM' : 'NÃO'}</span><br/>
                <span>Data de quitação inicial: {this.state.recInfo.rec_dtQuitIni ? moment(this.state.recInfo.rec_dtQuitIni).format('DD/MM/YYYY') : '-'}</span><br/>
                <span>Data de quitação atualizada: {this.state.recInfo.rec_dtQuitAtual ? moment(this.state.recInfo.rec_dtQuitAtual).format('DD/MM/YYYY') : '-'}</span><br/>
                <span>Data limite faturamento: {this.state.recInfo.rec_dtNfPrev ? moment(this.state.recInfo.rec_dtNfPrev).format('DD/MM/YYYY') : '-'}</span><br/>
                <span>Risco: {this.state.recInfo.rec_risco ?? '-'}</span><br/>
              </Typography>
              <div style={{display: 'flex', justifyContent: 'end', marginTop: '20px'}}>
                <Button onClick={this.handleCloseReceitasModal}>Voltar</Button>
              </div>
            </Box>
          </Modal>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth, technicalDep: state.technicalDep })
const mapDispatchToProps = dispatch => bindActionCreators({ getProductsFromOikos }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Products)
